import React, { forwardRef } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { FormFieldProps } from "../../types";

export const FormField = forwardRef<HTMLInputElement, FormFieldProps>(
  ({ name, children, onChange, ...props }, ref) => {
    const { control } = useFormContext();

    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => {
          return React.cloneElement(children as React.ReactElement, {
            ...field,
            ref,
            error: !!error,
            helperText: error?.message,
            onChange: (e: any) => {
              field.onChange(e);
              if (onChange) onChange(e);
            },
            ...props,
          });
        }}
      />
    );
  }
);

FormField.displayName = "FormField";
